import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresListaItemActivoComponent {
  constructor() {
    this.data = undefined
  }

  $onInit() {
    this.rfc = validarRfc(this.data.rfc)
      ? 'RFC: ' + this.data.rfc
      : null

    this.curp = validarCurp(this.data.curp)
      ? 'CURP: ' + this.data.curp
      : null

    this.cuenta = this.data.cuentas > 0
      ? 'Cuentas bancarias: ' + this.data.cuentas
      : null
  }
}

function validarRfc(rfc) {
  return rfc && /^[A-Z]{3,4}(\d{6})((\D|\d){3})?$/
    .test(rfc)
}

function validarCurp(curp) {
  return curp && /^[A-Z]{1}[AEIOU]{1}[A-Z]{2}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[0-9A-Z]{1}[0-9]{1}$/
    .test(curp)
}

module.component('fanProyectoColaboradoresListaItemActivo', {
  controller: FanProyectoColaboradoresListaItemActivoComponent,
  template: template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/lista/item/activo/component.js